import { apiRoutes } from '@features/campaigns/details/consts/apiRoutes';
import { CampaignDetails } from '@features/campaigns/shared/types/campaign.ts';
import { apiClient } from '@shared/api/ApiClient.ts';
import { CampaignId } from '@shared/types/campaign';

export async function approveCampaignBudget(campaignId: CampaignId): Promise<CampaignDetails | null> {
  return await apiClient.post<never, CampaignDetails>(apiRoutes.approveCampaignBudget(campaignId));
}
